var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g2, _path73, _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _path74, _path75, _path76, _path77, _path78, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _g3, _rect17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustration = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 135,
    viewBox: "0 0 218 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.176 52.1197C131.176 52.1645 131.176 52.1869 131.176 52.2318C131.199 53.2628 131.557 68.4823 131.378 74.2877C131.176 80.2948 130.997 96.4108 130.997 106.497C130.997 113.715 131.042 118.848 131.087 121.179C131.087 121.941 131.737 122.569 132.499 122.546C134.785 122.479 139.447 122.457 143.101 122.905C148.167 123.532 161.75 122.748 172.173 123.376C181.273 123.936 204.181 123.039 209.896 122.793C210.636 122.77 211.219 122.165 211.219 121.425C211.286 116.248 211.51 97.1953 211.51 90.6503C211.51 83.0742 210.569 63.327 210.412 55.2577C210.3 50.0351 210.143 46.8074 210.031 45.1936C209.986 44.4539 209.381 43.8936 208.641 43.8936C201.693 43.9384 169.012 44.2074 163.633 44.2074C157.626 44.2074 142.451 44.835 142.451 44.835L132.79 45.2608C132.073 45.2833 131.513 45.866 131.468 46.5609L131.176 52.1197Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.777 85.6965C157.777 85.6965 156.5 81.4378 155.469 78.7032C154.438 75.9686 148.812 79.3756 148.812 79.3756C148.812 79.3756 149.237 84.912 152.039 84.5982C152.689 87.0638 152.667 87.0638 152.667 87.0638L157.777 85.6965Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.87 63.1309H144.216C142.731 63.1309 141.196 64.7596 141.179 66.2446C141.142 69.5263 140.984 74.4115 141.094 76.0254C141.259 78.45 140.768 80.7915 142.495 81.9971C143.649 82.8032 144.786 82.3625 146.549 82.3625C148.313 82.3625 155.421 82.5278 157.24 82.3625C157.796 82.3119 158.373 82.2923 158.906 82.2894C160.098 82.2829 161.125 81.3625 161.145 80.1705C161.177 78.3161 161.196 75.7769 161.097 74.5927C160.999 73.4179 160.855 69.4333 160.749 66.1609C160.695 64.473 159.313 63.1309 157.625 63.1309H154.87Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 0.346857
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.414 68.3135H152.379L148.235 72.1284L150.007 74.0792C150.007 74.0792 148.356 75.7587 147.871 75.9723C147.871 75.9723 144.628 72.7575 144.449 72.5498C144.27 72.3362 148.414 68.3135 148.414 68.3135Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.353794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.016 71.9152L153.759 73.7159C153.759 73.7159 150.036 77.4731 149.886 77.5597C149.736 77.6521 153.522 77.5597 153.522 77.5597C153.522 77.5597 157.129 73.9872 157.458 73.6524C157.787 73.3234 157.551 73.0522 157.187 72.7232C156.829 72.3942 154.094 69.8721 154.094 69.8721L152.016 71.9152Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.353794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.692 58.2447C146.975 58.0773 147.535 58.389 147.8 59.0642C148.066 59.7395 147.921 60.4148 147.898 60.536C147.875 60.6572 147.015 60.1955 146.767 59.4683C146.519 58.7526 146.409 58.4178 146.692 58.2447Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.353794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.124 57.6445C151.661 57.6099 151.638 58.493 151.638 58.8508C151.638 59.2086 151.332 60.0859 151.124 60.109C150.911 60.1321 150.611 59.0932 150.616 58.5391C150.622 57.9851 150.755 57.6676 151.124 57.6445Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.353794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.686 60.6856C154.443 60.7145 154.42 59.6698 154.686 59.185C154.951 58.7002 155.413 58.0307 155.701 58.1981C155.99 58.3655 155.892 59.2139 155.701 59.5486C155.505 59.8892 155.072 60.6395 154.686 60.6856Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.353794,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.19 94.1359L177.293 95.0328C177.158 95.1682 177.158 95.3879 177.293 95.5233L178.19 96.4202C178.325 96.5557 178.545 96.5557 178.681 96.4202L179.577 95.5233C179.713 95.3879 179.713 95.1682 179.577 95.0328L178.681 94.1359C178.545 94.0004 178.325 94.0004 178.19 94.1359Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 0.346857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M178.19 96.7375L177.64 97.2875C177.504 97.4229 177.504 97.6426 177.64 97.778L178.19 98.3281C178.325 98.4635 178.545 98.4635 178.68 98.3281L179.23 97.778C179.366 97.6426 179.366 97.4229 179.23 97.2875L178.68 96.7375C178.545 96.602 178.325 96.602 178.19 96.7375Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 0.346857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M179.25 98.0023L179.228 96.3212L185.817 94.3936L185.683 98.0247L179.25 98.0023Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.343 95.7384C182.343 95.7384 180.819 96.7919 179.362 96.9488C178.958 96.9936 178.532 96.9712 178.174 96.8143C176.515 96.1418 175.484 94.4832 176.179 92.8917C178.42 87.714 180.953 85.4949 180.953 85.4949L184.808 85.4053L184.786 93.2504C184.786 93.2504 186.333 92.1745 186.736 93.8107C187.139 95.4694 185.077 95.6263 184.651 94.9539",
    fill: "#9C768C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.343 95.7384C182.343 95.7384 180.819 96.7919 179.362 96.9488C178.958 96.9936 178.532 96.9712 178.174 96.8143C176.515 96.1418 175.484 94.4832 176.179 92.8917C178.42 87.714 180.953 85.4949 180.953 85.4949L184.808 85.4053L184.786 93.2504C184.786 93.2504 186.333 92.1745 186.736 93.8107C187.139 95.4694 185.077 95.6263 184.651 94.9539",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.743 86.8393C179.743 86.8393 181.917 87.2876 183.329 86.1445C182.612 88.2514 183.755 91.5688 184.585 93.3619C185.974 92.7343 186.468 92.5774 186.804 93.9223C187.745 92.1067 189.157 90.3808 189.157 89.7532C189.157 89.1256 187.924 86.391 186.647 85.5617C185.19 84.6203 183.464 84.1047 182.142 84.5754C180.819 85.0686 179.743 86.8393 179.743 86.8393Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.579 85.0688C186.579 85.0688 185.727 81.1687 187.386 79.5997C189.045 78.0082 193.303 75.8788 196.105 77.4254C198.907 78.972 199.826 83.4101 199.557 84.7326C199.288 86.055 198.167 89.4845 195.365 90C192.564 90.5155 190.031 90.0448 188.977 88.3189C187.901 86.5706 186.579 85.0688 186.579 85.0688Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.102 89.9101C193.102 89.9101 200.229 91.7929 199.31 85.1582",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M197.226 88.8569C197.226 88.8569 203.322 86.3913 198.705 80.5859",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.386 79.5774C187.386 79.5774 190.479 74.1307 195.836 77.2239",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M192.451 78.1428C192.451 78.1428 186.892 77.291 185.66 80.9446C184.404 84.5757 188.529 86.5706 188.529 86.5706",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.86 90.7843C177.053 90.1791 176.717 88.6773 177.994 87.96C179.272 87.2652 180.975 88.229 180.527 89.8429C180.169 91.1429 178.398 91.1877 177.86 90.7843Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M180.303 91.9725C180.303 91.9725 180.347 90.4035 181.647 90.1345C182.947 89.8655 183.889 90.7621 183.844 92.1742C183.799 93.5864 181.894 93.9226 181.065 93.295C180.213 92.6674 180.303 91.9725 180.303 91.9725Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M178.062 90.2913C178.062 90.2913 178.555 88.7671 179.518 88.5205C179.227 89.7309 178.062 90.2913 178.062 90.2913Z",
    fill: "#040222"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M181.244 92.5998C181.244 92.5998 181.737 91.0757 182.701 90.8291C182.41 92.0395 181.244 92.5998 181.244 92.5998Z",
    fill: "#040222"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M179.676 91.9282C179.676 91.9282 178.376 92.1075 179.003 91.5247C179.631 90.9419 180.438 90.2471 180.438 90.2471",
    fill: "#9C768C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.676 91.9282C179.676 91.9282 178.376 92.1075 179.003 91.5247C179.631 90.9419 180.438 90.2471 180.438 90.2471",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M178.622 92.4209C178.622 92.4209 177.927 93.1606 178.353 93.5865C178.555 93.7882 179.25 93.0485 179.25 93.0485",
    fill: "#9C768C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.622 92.4209C178.622 92.4209 177.927 93.1606 178.353 93.5865C178.555 93.7882 179.25 93.0485 179.25 93.0485",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.266 82.1996C155.266 82.1996 153.383 79.5547 152.577 79.9133C151.77 80.2719 154.975 84.1945 154.975 84.1945",
    fill: "#9C768C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.266 82.1996C155.266 82.1996 153.383 79.5547 152.577 79.9133C151.77 80.2719 154.975 84.1945 154.975 84.1945",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M178.017 101.566C178.017 101.566 177.905 98.3383 178.241 98.1366C178.577 97.9349 185.84 98.0021 186.759 97.9573C187.678 97.9349 187.476 102.216 187.476 102.216C187.476 102.216 190.278 102.418 192.161 102.597C194.043 102.776 203.243 123.216 203.243 123.216L193.55 123.398L171.472 123.331L173.019 113.154C173.019 113.154 152.958 107.954 150.873 87.669C155.311 86.1896 158.091 85.3379 158.091 85.3379C158.091 85.3379 159.615 100.244 178.017 101.566Z",
    fill: "#E473FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M179.586 98.8535C179.586 98.8535 179.855 100.109 179.788 101.454L179.586 98.8535Z",
    fill: "#E473FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M179.586 98.8535C179.586 98.8535 179.855 100.109 179.788 101.454",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M181.558 98.8535C181.558 98.8535 181.357 101.252 181.76 101.566L181.558 98.8535Z",
    fill: "#E473FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M181.558 98.8535C181.558 98.8535 181.357 101.252 181.76 101.566",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M183.374 99.0557L183.576 101.768",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M185.66 99.0107C185.66 99.0107 185.19 100.781 185.66 101.342V99.0107Z",
    fill: "#E473FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M185.66 99.0107C185.66 99.0107 185.19 100.781 185.66 101.342",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M191.219 115.037L194.357 121.739",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M190.166 117.839C190.166 117.839 192.699 120.17 195.164 122.434L190.166 117.839Z",
    fill: "#9C768C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M190.166 117.839C190.166 117.839 192.699 120.17 195.164 122.434",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M190.39 118.018C190.39 118.018 186.983 114.454 185.459 114.454C183.957 114.454 177.703 114.589 177.659 115.283C177.614 115.956 178.241 116.247 179.16 116.247C180.079 116.247 184.159 115.575 184.159 115.575C184.159 115.575 178.734 118.421 179.093 119.385C179.452 120.349 184.988 116.539 184.988 116.539C184.988 116.539 180.528 120.349 181.11 120.82C181.693 121.291 185.683 117.435 185.683 117.435C185.683 117.435 182.881 120.484 183.06 121.201C183.24 121.918 185.997 118.534 185.997 118.534L186.938 121.627L190.39 118.018Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M184.781 94.4826L183.884 95.3795C183.748 95.5149 183.748 95.7345 183.884 95.87L184.781 96.7669C184.916 96.9023 185.136 96.9023 185.271 96.7669L186.168 95.87C186.304 95.7345 186.304 95.5149 186.168 95.3795L185.271 94.4826C185.136 94.3471 184.916 94.3471 184.781 94.4826Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 0.346857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M184.781 97.0841L184.231 97.6342C184.095 97.7696 184.095 97.9892 184.231 98.1247L184.781 98.6747C184.916 98.8102 185.136 98.8102 185.271 98.6747L185.821 98.1247C185.957 97.9892 185.957 97.7696 185.821 97.6342L185.271 97.0841C185.136 96.9487 184.916 96.9487 184.781 97.0841Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 0.346857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M153.115 123.308L147.601 108.604H164.815L170.508 123.51L153.115 123.308Z",
    fill: "#FCF1FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M165.801 108.582L164.814 108.604L170.508 123.51H185.212L185.055 122.501H171.36L165.801 108.582Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M152.371 55.3401C153.032 55.3401 153.527 54.75 153.409 54.1127C152.819 50.926 153.079 48.7307 153.079 44.5762C153.079 39.9024 148.405 26.5892 142.386 18.7995C136.367 11.0099 130.513 5.98202 124.139 3.95199C117.766 1.92196 115.405 1.92196 112.856 1.92196C110.307 1.92196 105.869 0.694499 103.272 1.07218C100.676 1.44986 89.7702 4.14083 81.6265 9.31033C73.4828 14.4798 66.7081 25.0077 63.9227 32.16C61.6094 38.1793 60.8069 50.4775 60.618 54.2307C60.5944 54.8208 61.0665 55.3401 61.6567 55.3401H152.371Z",
    fill: "#A0ECE5",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4036 47.0321C88.4036 47.0321 95.1504 47.3235 105.416 47.7942C106.044 48.1304 106.559 49.0494 106.963 50.1702C107.815 52.5461 108.173 55.7962 108.173 55.7962C108.173 55.7962 82.9344 55.7066 79.6395 55.6393C76.3446 55.5721 79.3705 49.4305 85.6018 39.5681C91.833 29.7057 97.1453 27.1729 97.1453 27.1729L115.884 30.4005C115.884 30.4005 121.734 57.298 137.716 64.4931C132.179 71.8675 131.103 72.7416 131.103 72.7416C131.103 72.7416 114.701 68.4764 109.748 51.2844C107.685 51.3517 107.355 50.6089 107.355 50.6089",
    fill: "#ECFBFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4036 47.0321C88.4036 47.0321 95.1504 47.3235 105.416 47.7942C106.044 48.1304 106.559 49.0494 106.963 50.1702C107.815 52.5461 108.173 55.7962 108.173 55.7962C108.173 55.7962 82.9344 55.7066 79.6395 55.6393C76.3446 55.5721 79.3705 49.4305 85.6018 39.5681C91.833 29.7057 97.1453 27.1729 97.1453 27.1729L115.884 30.4005C115.884 30.4005 121.734 57.298 137.716 64.4931C132.179 71.8675 131.103 72.7416 131.103 72.7416C131.103 72.7416 114.701 68.4764 109.748 51.2844C107.685 51.3517 107.355 50.6089 107.355 50.6089",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1106_10827",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 26,
    width: 60,
    height: 47
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4036 47.0321C88.4036 47.0321 95.1504 47.3235 105.416 47.7942C106.044 48.1304 106.559 49.0494 106.963 50.1702C107.815 52.5461 108.173 55.7962 108.173 55.7962C108.173 55.7962 82.9344 55.7066 79.6395 55.6393C76.3446 55.5721 79.3705 49.4305 85.6018 39.5681C91.833 29.7057 97.1453 27.1729 97.1453 27.1729L115.884 30.4005C115.884 30.4005 121.734 57.298 137.716 64.4931C132.179 71.8675 131.103 72.7416 131.103 72.7416C131.103 72.7416 114.451 67.988 109.498 50.796C107.435 50.8633 107.075 50.1029 107.075 50.1029",
    fill: "#ECFCFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4036 47.0321C88.4036 47.0321 95.1504 47.3235 105.416 47.7942C106.044 48.1304 106.559 49.0494 106.963 50.1702C107.815 52.5461 108.173 55.7962 108.173 55.7962C108.173 55.7962 82.9344 55.7066 79.6395 55.6393C76.3446 55.5721 79.3705 49.4305 85.6018 39.5681C91.833 29.7057 97.1453 27.1729 97.1453 27.1729L115.884 30.4005C115.884 30.4005 121.734 57.298 137.716 64.4931C132.179 71.8675 131.103 72.7416 131.103 72.7416C131.103 72.7416 114.451 67.988 109.498 50.796C107.435 50.8633 107.075 50.1029 107.075 50.1029",
    stroke: "black",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1106_10827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.4555 31.6777C94.4555 31.6777 96.54 31.319 96.54 33.5605C96.54 35.8019 94.0744 34.7485 94.0744 34.7485C94.0744 34.7485 95.3297 37.6624 93.8503 37.8641C92.3709 38.0658 90.5554 36.6761 90.9588 34.8381C89.4346 36.5192 86.9018 35.4657 87.5518 33.5157C88.2018 31.5656 90.1967 31.2966 90.1967 31.2966C90.1967 31.2966 86.969 28.7414 88.9415 27.912C90.914 27.1051 92.3934 29.5035 92.3934 29.5035C92.3934 29.5035 94.8141 26.5896 95.8228 28.3379C96.8538 30.0862 94.4555 31.6777 94.4555 31.6777Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5192 47.3008C91.5192 47.3008 93.4692 46.5163 93.9623 48.6905C94.433 50.8871 91.8105 50.3716 91.8105 50.3716C91.8105 50.3716 93.6485 52.9716 92.2588 53.4648C90.8691 53.9579 88.7846 52.9941 88.807 51.1112C87.6638 53.0613 84.9741 52.5682 85.1983 50.5285C85.4224 48.4887 87.3052 47.8163 87.3052 47.8163C87.3052 47.8163 83.6068 46.0007 85.3552 44.7903C87.1035 43.58 89.076 45.6197 89.076 45.6197C89.076 45.6197 90.8243 42.2575 92.1916 43.7593C93.5589 45.261 91.5192 47.3008 91.5192 47.3008Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.095 45.7989C117.095 45.7989 117.319 47.9059 115.077 47.749C112.836 47.5921 114.046 45.2161 114.046 45.2161C114.046 45.2161 111.043 46.2696 110.953 44.7903C110.863 43.3109 112.343 41.585 114.158 42.1229C112.589 40.4867 113.8 38.0435 115.705 38.828C117.61 39.6125 117.745 41.6074 117.745 41.6074C117.745 41.6074 120.502 38.559 121.197 40.5763C121.891 42.5936 119.381 43.9161 119.381 43.9161C119.381 43.9161 122.138 46.5162 120.322 47.4128C118.507 48.2869 117.095 45.7989 117.095 45.7989Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.273 64.1339C117.273 64.1339 117.498 66.2408 115.256 66.0839C113.015 65.927 114.225 63.5511 114.225 63.5511C114.225 63.5511 111.221 64.6046 111.132 63.1252C111.042 61.6459 112.522 59.9199 114.337 60.4579C112.768 58.8216 113.978 56.3784 115.884 57.1629C117.789 57.9475 117.923 59.9424 117.923 59.9424C117.923 59.9424 120.68 56.894 121.375 58.9113C122.07 60.9286 119.56 62.251 119.56 62.251C119.56 62.251 122.317 64.8511 120.501 65.7477C118.708 66.6219 117.273 64.1339 117.273 64.1339Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.212 55.8858C128.212 55.8858 128.436 57.9928 126.195 57.8359C123.953 57.7014 125.163 55.303 125.163 55.303C125.163 55.303 122.16 56.3565 122.07 54.8772C121.981 53.3978 123.46 51.6719 125.276 52.2098C123.707 50.5736 124.917 48.1304 126.822 48.9149C128.727 49.6994 128.862 51.6943 128.862 51.6943C128.862 51.6943 131.619 48.6459 132.314 50.6632C133.009 52.6805 130.498 54.003 130.498 54.003C130.498 54.003 133.255 56.6031 131.44 57.4997C129.646 58.3738 128.212 55.8858 128.212 55.8858Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.229 70.0742C130.229 70.0742 128.795 71.6208 127.427 69.8276C126.06 68.0345 128.683 67.3844 128.683 67.3844C128.683 67.3844 125.926 65.8154 126.979 64.7619C128.033 63.7309 130.319 63.7085 131.103 65.4344C131.328 63.1705 133.973 62.4981 134.623 64.4481C135.273 66.3982 133.86 67.8103 133.86 67.8103C133.86 67.8103 137.985 67.9 136.909 69.738C135.833 71.576 133.188 70.5673 133.188 70.5673C133.188 70.5673 133.031 74.3554 131.148 73.5709C129.265 72.7864 130.229 70.0742 130.229 70.0742Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.435 57.499C102.435 57.499 101.001 59.0456 99.6335 57.2524C98.2662 55.4817 100.889 54.8093 100.889 54.8093C100.889 54.8093 98.1318 53.2402 99.1852 52.1868C100.239 51.1557 102.525 51.1333 103.31 52.8592C103.534 50.5953 106.179 49.9229 106.829 51.873C107.479 53.823 106.067 55.2351 106.067 55.2351C106.067 55.2351 110.191 55.3248 109.115 57.1628C108.039 59.0008 105.394 57.9921 105.394 57.9921C105.394 57.9921 105.237 61.7802 103.354 60.9957C101.472 60.2112 102.435 57.499 102.435 57.499Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.522 33.6728C112.522 33.6728 111.088 35.2194 109.72 33.4263C108.353 31.6331 110.976 30.9831 110.976 30.9831C110.976 30.9831 108.219 29.4141 109.272 28.3606C110.326 27.3295 112.612 27.3071 113.396 29.033C113.621 26.7691 116.265 26.0967 116.916 28.0468C117.566 29.9968 116.153 31.409 116.153 31.409C116.153 31.409 120.278 31.4986 119.202 33.3366C118.126 35.1746 115.481 34.1659 115.481 34.1659C115.481 34.1659 115.324 37.954 113.441 37.1695C111.581 36.385 112.522 33.6728 112.522 33.6728Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.256 37.7524C102.256 37.7524 101.943 35.6678 104.184 35.7126C106.425 35.7575 105.305 38.2006 105.305 38.2006C105.305 38.2006 108.263 37.0351 108.42 38.5144C108.577 39.9938 107.143 41.7646 105.305 41.3163C106.941 42.8853 105.82 45.3957 103.87 44.6784C101.943 43.9612 101.741 41.9887 101.741 41.9887C101.741 41.9887 99.0959 45.1491 98.3338 43.1543C97.5717 41.1594 100.015 39.7472 100.015 39.7472C100.015 39.7472 97.1683 37.2592 98.939 36.2954C100.732 35.3092 102.256 37.7524 102.256 37.7524Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9637 55.4151C75.9637 55.4151 74.5291 56.9617 73.1619 55.1685C71.7946 53.3753 74.4171 52.7477 74.4171 52.7477C74.4171 52.7477 71.6601 51.1787 72.7136 50.1252C73.767 49.0717 76.0533 49.0717 76.8378 50.7977C77.062 48.5338 79.7069 47.8614 80.3569 49.8114C81.0069 51.7615 79.5948 53.1736 79.5948 53.1736C79.5948 53.1736 83.7191 53.2633 82.6432 55.1013C81.5673 56.9393 78.9224 55.9306 78.9224 55.9306C78.9224 55.9306 78.7431 59.6962 76.8827 58.9117C75.0223 58.1272 75.9637 55.4151 75.9637 55.4151Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4036 47.0321C88.4036 47.0321 95.1504 47.3235 105.416 47.7942C106.044 48.1304 106.559 49.0494 106.963 50.1702C107.815 52.5461 108.173 55.7962 108.173 55.7962C108.173 55.7962 82.9344 55.7066 79.6395 55.6393C76.3446 55.5721 79.3705 49.4305 85.6018 39.5681C91.833 29.7057 97.1453 27.1729 97.1453 27.1729L115.884 30.4005C115.884 30.4005 121.734 57.298 137.716 64.4931C132.179 71.8675 131.103 72.7416 131.103 72.7416C131.103 72.7416 114.46 68.0918 109.506 50.8998C107.444 50.967 107.202 50.8998 107.202 50.8998",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M94.68 39.7021L91.9902 47.211",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M113.643 42.8633L113.117 51.7169",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M113.486 11.729C113.486 11.729 111.917 10.2945 108.442 10.81C104.968 11.3256 101.651 18.2517 101.651 18.2517C101.651 18.2517 95.8229 18.2517 94.8142 22.3311C93.8056 26.4106 97.9523 24.864 97.9523 24.864C97.9523 24.864 92.9314 25.5812 94.0746 29.19C95.1953 32.7987 98.3781 29.9297 98.6471 28.7417C98.9161 27.5537 97.1229 27.733 95.9574 29.9072C94.7694 32.0814 95.4418 35.7798 97.6161 35.466C99.7903 35.1522 101.494 31.4538 100.844 30.2883C100.194 29.1227 98.8713 30.9831 99.2523 32.7987C99.6334 34.6143 101.83 35.4436 102.39 32.4625C102.951 29.4814 104.071 27.2847 104.071 27.2847L111.446 28.1141C111.446 28.1141 110.751 32.6866 112.029 34.0988C113.306 35.5109 115.682 35.1747 116.063 32.8211C116.444 30.4676 114.539 31.2745 114.741 32.6866C114.92 34.0763 115.794 35.6902 117.498 35.7574C119.201 35.8247 118.753 32.7763 118.753 32.7763C118.753 32.7763 118.932 35.7798 120.793 34.7936C122.631 33.8074 120.681 29.6159 120.681 29.6159C120.681 29.6159 122.25 26.2313 120.569 23.0932C119.627 21.0983 117.61 21.0535 117.61 21.0535C117.61 21.0535 118.618 16.7499 118.215 14.9567C117.767 13.2084 115.368 11.9532 113.486 11.729Z",
    fill: "#FFA38A",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M107.748 24.124C107.748 24.124 108.779 27.3965 112.32 26.2982C113.553 25.8723 113.934 25.4464 114.36 24.7067C114.786 23.9671 115.884 19.8652 115.884 19.8652C115.884 19.8652 113.62 19.3273 113.396 16.0771C113.396 16.0771 111.984 18.8117 107.77 18.9462C107.165 20.448 106.201 20.0894 106.201 19.2824C106.201 19.0135 106.022 18.8566 105.798 18.7893C105.305 18.6548 104.587 18.991 104.722 19.91C104.946 21.2325 106.067 21.2325 106.067 21.2325L104.049 27.3292C104.049 27.3292 103.377 31.7673 106.851 32.238C110.326 32.7087 111.088 29.9517 111.424 28.1586C111.289 28.1586 110.415 27.7775 110.415 27.7775L110.662 26.6792",
    fill: "#FAE900"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M107.748 24.124C107.748 24.124 108.779 27.3965 112.32 26.2982C113.553 25.8723 113.934 25.4464 114.36 24.7067C114.786 23.9671 115.884 19.8652 115.884 19.8652C115.884 19.8652 113.62 19.3273 113.396 16.0771C113.396 16.0771 111.984 18.8117 107.77 18.9462C107.165 20.448 106.201 20.0894 106.201 19.2824C106.201 19.0135 106.022 18.8566 105.798 18.7893C105.305 18.6548 104.587 18.991 104.722 19.91C104.946 21.2325 106.067 21.2325 106.067 21.2325L104.049 27.3292C104.049 27.3292 103.377 31.7673 106.851 32.238C110.326 32.7087 111.088 29.9517 111.424 28.1586C111.289 28.1586 110.415 27.7775 110.415 27.7775L110.662 26.6792",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M112.32 20.1338L112.858 22.2632C112.858 22.2632 112.32 22.577 111.356 22.4873",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M109.406 20.3583L110.751 19.8428L111.222 20.8738",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M110.303 20.9412L110.661 19.8877",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M113.015 21.2995L114.158 20.6719L114.853 21.9047",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M113.755 21.8379L114.091 20.8965",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M110.159 22.5039C110.159 22.5039 110.195 22.522 110.25 22.5401C110.503 22.6666 111.28 22.9738 111.533 23.4617C112.075 22.9557 112.852 23.3714 112.852 23.3714C112.852 23.3714 112.4 24.6003 111.298 24.2569C110.177 23.9497 110.159 22.5039 110.159 22.5039Z",
    fill: "#ED7976",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M112.653 23.4798C112.563 23.534 111.298 24.5822 110.304 22.6846",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M106.111 18.9018C106.111 18.9018 106.358 12.5361 111.199 11.9085C114.158 11.5722 117.588 13.074 116.781 19.1708C116.579 17.288 116.288 13.7689 112.97 13.4327C106.829 12.8275 106.111 18.9018 106.111 18.9018Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M113.262 13.4548C113.262 13.4548 109.81 12.0875 110.572 7.20117C111.961 8.25466 113.239 9.66677 113.486 10.5858C113.732 11.5048 113.262 13.4548 113.262 13.4548Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M113.351 13.2759C113.351 13.2759 114.561 10.1155 119.021 9.28613C118.349 11.6621 117.43 12.6707 115.502 13.2311C113.575 13.7915 113.351 13.2759 113.351 13.2759Z",
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M108.186 55.6566C108.186 55.6566 109.888 54.6283 110.022 56.2422C110.279 59.3228 110.743 62.9982 111.146 63.0206C111.55 63.043 111.95 65.1632 111.547 56.3542C112.264 65.5218 112.959 64.3338 112.959 64.3338C114.124 64.1769 113.004 55.7939 113.004 55.7939C113.004 55.7939 114.079 64.8045 114.774 64.4907C115.469 64.1769 114.662 57.2284 113.81 53.2835C112.959 49.3385 107.022 50.3682 107.022 50.3682C107.022 50.3682 107.962 53.4376 108.186 55.6566Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M139.691 67.4741C139.691 67.4741 140.35 67.4741 143.057 67.4741C145.764 67.4741 144.985 66.4206 144.985 66.4206C144.985 66.4206 142.849 65.6585 140.54 65.3223C138.232 64.986 137.738 66.3982 137.738 66.3982L136.618 65.905L133.592 69.7603C136.169 73.257 138.608 73.4667 140.917 73.6236C140.917 70.0801 141.386 67.4741 141.386 67.4741",
    fill: "#FAE900"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M139.691 67.4741C139.691 67.4741 140.35 67.4741 143.057 67.4741C145.764 67.4741 144.985 66.4206 144.985 66.4206C144.985 66.4206 142.849 65.6585 140.54 65.3223C138.232 64.986 137.738 66.3982 137.738 66.3982L136.618 65.905L133.592 69.7603C136.169 73.257 138.608 73.4667 140.917 73.6236C140.917 70.0801 141.386 67.4741 141.386 67.4741",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M140.002 71.7998L140.63 71.9567",
    stroke: "#040222",
    strokeWidth: 0.401691,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M140.406 70.3428L140.832 70.4548",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M140.697 68.8193H141.088",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63473 66.3124C4.39553 60.0646 16.6497 46.203 27.5952 41.8587C38.5407 37.5143 50.3428 36.8649 63.5011 43.6278C76.6595 50.3906 85.8918 60.6916 88.7947 76.1208C91.6977 91.5499 86.5818 97.6857 81.7754 106.218C76.9927 114.75 71.3533 123.931 47.0829 125.207C22.8125 126.484 14.0799 110.898 10.6773 108.143C7.27467 105.389 -3.3377 87.5638 2.63473 66.3124Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1106_10827",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 38,
    width: 90,
    height: 88
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63473 66.3124C4.39553 60.0646 16.6497 46.203 27.5952 41.8587C38.5407 37.5143 50.3428 36.8649 63.5011 43.6278C76.6595 50.3906 85.8918 60.6916 88.7947 76.1208C91.6977 91.5499 86.5818 97.6857 81.7754 106.218C76.9927 114.75 71.3533 123.931 47.0829 125.207C22.8125 126.484 14.0799 110.898 10.6773 108.143C7.27467 105.389 -3.3377 87.5639 2.63473 66.3124Z",
    fill: "#B5C1FF",
    stroke: "black",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1106_10827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.498 80.9984L60.0671 79.596C60.0671 79.596 59.3659 73.4855 59.3408 71.6824C59.3408 69.8542 60.7933 68.2765 61.1439 68.0511C61.4945 67.8257 62.0455 67.8007 61.9453 68.2514C61.9704 68.4518 61.5697 69.2782 61.3192 69.5787C61.0688 69.9043 60.9185 70.2799 60.8935 70.7808C60.8685 71.2817 61.0688 71.4069 61.3192 71.457C61.5697 71.5071 61.8702 71.3318 62.0705 71.0062C62.2959 70.6806 63.6983 66.8991 63.6983 66.8991L65.2761 63C65.4163 62.7681 65.449 62.5 65.9998 62.5C66.3606 62.5 66.6967 62.5 66.4998 63.5C66.3422 64.3 65.4681 66.634 65.0507 67.9509L64.4997 70.0045C64.4997 70.0045 68.8322 65.1461 69.0576 64.8706C69.283 64.6202 69.5334 64.52 69.7838 64.6703C70.0092 64.8205 70.2847 65.2713 69.9842 65.8974C69.7338 66.1979 65.8521 70.9561 65.8521 70.9561C65.8521 70.9561 65.9022 70.9812 66.3028 70.9311C66.7286 70.881 67.1042 71.1314 67.5049 71.7325C67.8806 72.3335 67.8305 72.8844 66.9289 73.761C66.0274 74.6375 65.2761 74.8629 65.2761 74.8629L65.6267 78.995L63.498 80.9984Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6268 71.833C65.6268 71.833 64.0741 73.2354 63.7986 73.6862C63.5231 74.137 63.6984 74.2121 63.7235 74.2622C63.7736 74.3123 64.1743 74.3874 64.575 74.1119C64.9756 73.8365 66.7287 72.3589 66.7287 72.3589L64.575 74.1119C64.575 74.1119 63.999 74.5878 64.2744 74.9384C64.5499 75.289 64.9506 75.0135 64.9506 75.0135",
    stroke: "#040222",
    strokeWidth: 0.368966,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0186 75.0633C61.0186 75.0633 61.6446 74.7628 62.1455 74.0366C62.5963 73.3854 62.6464 72.6592 62.6464 72.6592",
    stroke: "#040222",
    strokeWidth: 0.184494,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6966 76.4654C62.6966 76.4654 62.6715 74.8626 63.0973 74.4619",
    stroke: "#040222",
    strokeWidth: 0.184494,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.006 94.7969L43.7133 93.9704L43.6883 101.108C43.6883 101.108 22.6519 102.26 17.9438 101.884C13.2107 101.508 14.0371 98.0024 16.2409 95.1475C18.4447 92.3176 35.8247 73.5352 35.8247 73.5352L50.3748 74.2614L60.4672 88.0352L59.766 76.365L65.4258 76.1647C65.4258 76.1647 67.7047 95.8737 67.5545 98.4031C67.4042 100.932 63.1719 99.3297 59.7911 97.6768C56.4102 96.024 54.7073 94.6466 54.7073 94.6466L55.9094 105.315L25.9577 105.49L26.2081 101.884",
    fill: "#F1F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.006 94.7969L43.7133 93.9704L43.6883 101.108C43.6883 101.108 22.6519 102.26 17.9438 101.884C13.2107 101.508 14.0371 98.0024 16.2409 95.1475C18.4447 92.3176 35.8247 73.5352 35.8247 73.5352L50.3748 74.2614L60.4672 88.0352L59.766 76.365L65.4258 76.1647C65.4258 76.1647 67.7047 95.8737 67.5545 98.4031C67.4042 100.932 63.1719 99.3297 59.7911 97.6768C56.4102 96.024 54.7073 94.6466 54.7073 94.6466L55.9094 105.315L25.9577 105.49L26.2081 101.884",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.129 68.8767L35.9502 73.3094C35.9502 73.3094 36.9269 77.166 39.5564 77.5417C42.186 77.9173 50.1747 78.1177 50.4252 76.6651C50.6756 75.3379 50.4252 73.685 50.4252 73.685C50.4252 73.685 51.0012 72.1323 51.8276 68.451C52.7292 64.5192 45.5668 63.3672 45.5668 63.3672L41.3846 64.1185L38.129 68.8767Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1289 68.8772C38.1289 68.8772 39.6565 63.7684 43.0374 62.3409C46.4433 60.9134 50.35 62.8918 51.527 64.7951C52.7041 66.6984 51.502 69.378 51.502 69.378C51.502 69.378 49.8992 67.9506 50.4752 65.7217C49.6237 66.6483 48.9225 66.3478 49.2231 65.1708C48.5218 67.1993 47.6453 67.0991 47.6954 65.9221C47.7455 64.745 47.7455 64.745 47.7455 64.745C47.7455 64.745 46.894 67.4247 45.9174 67.3245C44.9407 67.1993 45.3664 64.4445 45.3664 64.4445C45.3664 64.4445 44.6151 67.3746 43.4631 67.2243C42.3111 67.0741 41.9605 64.4445 42.7118 64.4696C43.4631 64.4946 43.6635 67.4748 41.5849 67.8754C39.4812 68.2511 38.1289 68.8772 38.1289 68.8772Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6821 76.2148C39.6821 76.2148 38.9559 72.834 41.36 73.6604C42.9127 74.1863 42.2115 77.5671 42.2115 77.5671C42.2115 77.5671 44.1649 74.2614 45.6174 75.3633C47.0699 76.4652 46.6692 78.4687 46.6692 78.4687C46.6692 78.4687 47.3704 74.3365 48.3471 74.9125C49.3238 75.4885 49.474 75.188 49.7495 76.8158C49.449 73.3849 50.3756 73.6854 50.3756 73.6854C50.3756 73.6854 50.7262 78.3685 49.8246 78.4937C48.9231 78.6189 49.3238 79.7459 48.1968 79.6708C47.0699 79.5956 47.0699 77.8927 47.0699 77.8927C47.0699 77.8927 46.2184 79.9462 45.5422 79.9462C44.8661 79.9462 44.9913 78.644 44.9913 78.644C44.9913 78.644 44.1649 80.372 43.113 79.8711C42.0612 79.3702 42.3117 78.1682 42.3117 78.1682C42.3117 78.1682 41.7357 79.1949 41.0094 78.7442C40.2832 78.3184 40.5586 77.0913 40.5586 77.0913C40.5586 77.0913 39.5569 78.1181 39.6821 76.2148Z",
    fill: "#FAE900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4249 73.8353C50.4249 73.8353 51.0509 78.5935 49.7988 78.5434C48.5466 78.4933 48.4965 75.5633 49.1226 75.6134C49.7487 75.6635 49.7236 79.7205 48.171 79.7455C46.6183 79.7705 47.2193 75.964 47.2193 75.964C47.2193 75.964 46.6183 80.1963 45.4913 80.046C44.3644 79.8958 45.3661 76.6401 45.3661 76.6401C45.3661 76.6401 44.9905 80.8224 43.0872 79.9709C41.1589 79.1194 43.538 73.7602 44.1641 75.0624C44.8152 76.3396 42.2858 79.4199 40.9585 78.869C39.6312 78.318 41.3843 73.8103 42.0855 74.1108C42.7867 74.4113 42.3109 76.4648 40.3324 77.4165C38.354 78.3932 40.1571 72.7334 40.1571 72.7334",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2846 68.2013C41.2846 68.2013 39.3563 67.0743 39.1058 68.7272C38.8554 70.4051 40.3079 70.4051 40.9841 69.804",
    fill: "#F1B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2846 68.2013C41.2846 68.2013 39.3563 67.0743 39.1058 68.7272C38.8554 70.4051 40.3079 70.4051 40.9841 69.804",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3643 69.4286C44.3643 69.4286 45.4912 68.4769 45.9921 69.078C46.2675 69.4536 46.3677 70.0296 46.3677 70.0296",
    fill: "#F1B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3643 69.4286C44.3643 69.4286 45.4912 68.4769 45.9921 69.078C46.2675 69.4536 46.3677 70.0296 46.3677 70.0296",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0605 70.2007C48.0605 70.2007 48.6523 69.4109 49.0702 69.4945C49.6963 69.6197 49.6734 70.4545 49.6734 70.4545",
    fill: "#F1B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0605 70.2007C48.0605 70.2007 48.6523 69.4109 49.0702 69.4945C49.6963 69.6197 49.6734 70.4545 49.6734 70.4545",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2444 68.2764L48.0601 72.1266L46.4434 71.4673",
    fill: "#F1B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2444 68.2764L48.0601 72.1266L46.4434 71.4673",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3027 72.8107C45.868 72.7527 45.8463 72.4922 45.4043 72.376C44.9844 72.2559 44.6877 72.4501 44.8036 73.1457C44.9195 73.8413 46.3317 74.2308 46.9403 73.941C47.549 73.6512 48.0706 72.9846 47.6939 72.5499C47.2591 72.1441 46.8824 72.9266 46.3027 72.8107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.636 72.5499L45.1373 73.6323M46.303 72.9266L46.1105 73.952M46.9404 72.6659L47.2012 73.7962M46.3027 72.8107C45.868 72.7527 45.8463 72.4922 45.4043 72.376C44.9844 72.2559 44.6877 72.4501 44.8036 73.1457C44.9195 73.8413 46.3317 74.2308 46.9403 73.941C47.549 73.6512 48.0706 72.9846 47.6939 72.5499C47.2591 72.1441 46.8824 72.9266 46.3027 72.8107Z",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1729 75.9902C35.1729 75.9902 36.9008 78.194 37.001 78.8702C37.1012 79.5714 37.6521 80.5481 38.0528 80.9238C38.4786 81.2994 39.2048 79.0706 40.0062 79.0455",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1101 82.0755C41.2587 82.2258 41.6844 83.528 42.1853 83.2776C42.6861 83.0272 42.8865 81.9503 42.1101 82.0755Z",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9852 85.3816C41.5094 85.6571 41.5344 86.6838 42.1104 86.6588C42.6864 86.6337 42.7115 84.9308 41.9852 85.3816Z",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2354 89.5884C41.7596 89.7387 41.4591 90.7404 42.2104 90.7404C42.9617 90.7404 42.9366 89.363 42.2354 89.5884Z",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8408 77.8182L61.3434 77.9183L61.6189 76.4658L62.5455 77.8182L64.6241 77.2923",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8356 91.1162L27.1094 94.5471",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8858 117.636C41.8858 117.636 47.5956 139.124 48.973 144.833C52.7545 145.234 61.7451 143.706 61.1941 143.606L55.91 105.365L25.9583 105.541L23.3037 137.095C23.3037 137.095 28.9134 141.703 35.7001 143.231C36.5516 138.297 39.4315 124.373 41.8858 117.636Z",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6424 113.43C45.6424 113.43 43.088 113.43 42.4118 115.684C41.7357 117.937 41.335 119.165 41.335 119.165",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3341 105.541C26.3341 105.541 25.3324 107.219 26.1588 107.645C26.86 107.995 33.3212 107.82 35.2245 107.745C35.55 107.72 35.8005 107.469 35.8255 107.144L35.9006 105.341L26.3341 105.541Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1782 105.365L37.028 107.043C37.0029 107.394 37.2784 107.694 37.6039 107.694C39.7326 107.72 46.4192 107.77 46.7948 107.619C47.2205 107.444 46.9451 105.24 46.9451 105.24L37.1782 105.365Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4216 105.391C48.4216 105.391 47.7204 107.369 49.0978 107.444C50.4752 107.52 56.0348 107.019 56.0348 107.019L55.9096 105.341L48.4216 105.391Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.4851,
    y: 54.9803,
    width: 71.55,
    height: 17.55,
    rx: 2.475,
    transform: "rotate(54.0422 22.4851 54.9803)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8279,
    y: 63.5789,
    width: 3.15,
    height: 3.15,
    rx: 0.675,
    transform: "rotate(54.0422 19.8279 63.5789)",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.7057,
    cy: 71.607,
    r: 3.375,
    transform: "rotate(54.0422 23.7057 71.607)",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3758,
    y: 74.4422,
    width: 22.05,
    height: 1.8,
    rx: 0.9,
    transform: "rotate(54.0422 29.3758 74.4422)",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.0975,
    y: 76.8201,
    width: 15.75,
    height: 1.8,
    rx: 0.9,
    transform: "rotate(54.0422 26.0975 76.8201)",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9685,
    y: 105.586,
    width: 7.875,
    height: 1.8,
    rx: 0.9,
    transform: "rotate(54.0422 51.9685 105.586)",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7088,
    y: 105.232,
    width: 11.25,
    height: 1.8,
    rx: 0.9,
    transform: "rotate(54.0422 46.7088 105.232)",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.4851,
    y: 54.9803,
    width: 71.55,
    height: 17.55,
    rx: 2.475,
    transform: "rotate(54.0422 22.4851 54.9803)",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3427 93.3703C46.2174 93.1198 46.3677 92.8443 46.6181 92.7692C47.144 92.619 47.9454 92.3184 48.0706 91.9178C48.2459 91.3167 47.3945 91.467 45.7917 91.5421C44.1889 91.6172 44.2641 94.1466 44.2641 94.1466C43.5128 94.1967 43.2373 94.2468 43.2373 94.2468L43.2874 100.057C43.2874 100.057 54.1061 99.606 53.9057 98.6043C53.7054 97.6026 48.3962 98.404 48.3962 98.404C48.3962 98.404 55.0327 98.2537 54.081 97.302C53.1294 96.3504 49.5983 96.5007 49.0974 97.0015C48.5966 97.4773 52.8789 97.7027 54.0059 96.1501C55.1328 94.5723 48.872 95.1233 48.872 95.1233C48.872 95.1233 52.7036 95.1233 53.5551 94.9981C54.4066 94.8728 55.1328 94.2969 53.9558 93.8461C53.2045 93.5706 49.5232 93.796 46.6181 93.9963L46.3427 93.3703Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7138 93.9707L25.0065 94.7971L17.9443 101.884C22.6525 102.26 43.6888 101.108 43.6888 101.108L43.7138 93.9707Z",
    fill: "#F1F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0065 94.7971L43.7138 93.9707L43.6888 101.108C43.6888 101.108 22.6525 102.26 17.9443 101.884M25.9582 105.491L26.2086 101.884",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3809 94.4463V96.4748L41.2341 96.6501L39.7315 97.8021L39.8567 100.757",
    stroke: "#040222",
    strokeWidth: 0.224145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63473 66.3124C4.39553 60.0646 16.6497 46.203 27.5952 41.8587C38.5407 37.5143 50.3428 36.8649 63.5011 43.6278C76.6595 50.3906 85.8918 60.6916 88.7947 76.1208C91.6977 91.5499 86.5818 97.6857 81.7754 106.218C76.9927 114.75 71.3533 123.931 47.0829 125.207C22.8125 126.484 14.0799 110.898 10.6773 108.143C7.27467 105.389 -3.3377 87.5638 2.63473 66.3124Z",
    stroke: "#040222",
    strokeWidth: 0.448291,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.225,
    y: 0.225,
    width: 39.55,
    height: 52.55,
    rx: 1.9,
    transform: "matrix(-1 0 0 1 119.55 80)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.225,
    y: 0.225,
    width: 22.4827,
    height: 1.8,
    rx: 0.9,
    transform: "matrix(-1 0 0 1 115.3 86.7246)",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.43557,
    transform: "matrix(-1 0 0 1 87.69 87.85)",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.328869
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.225,
    y: 0.225,
    width: 31.05,
    height: 11.2153,
    rx: 1.09048,
    transform: "matrix(-1 0 0 1 115.3 95.7002)",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.164434,
    y: 0.164434,
    width: 31.1711,
    height: 5.3984,
    rx: 0.98102,
    transform: "matrix(-1 0 0 1 115.421 111.615)",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.328869
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.225,
    y: 0.225,
    width: 24.55,
    height: 1.8,
    rx: 0.9,
    transform: "matrix(-1 0 0 1 115.3 121.593)",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.225,
    y: 0.225,
    width: 30.9865,
    height: 1.8,
    rx: 0.9,
    transform: "matrix(-1 0 0 1 115.3 125.843)",
    fill: "#6F86FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -0.225,
    y: 0.225,
    width: 39.55,
    height: 52.55,
    rx: 1.9,
    transform: "matrix(-1 0 0 1 119.55 80)",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M167.177 18.8611C163.033 18.422 159.889 16.8157 159.394 11.533C159.399 11.0532 159.377 10.5428 159.326 10C159.326 10.5426 159.349 11.053 159.394 11.533C159.337 17.8273 154.758 18.8611 151 18.8611C156.71 18.8611 159.326 21.735 159.326 27.2432C159.326 18.8611 163.846 18.8611 167.177 18.8611Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.491648,
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51.625C31.9509 51.3958 30.3961 50.5574 30.1513 47.8001C30.1535 47.5497 30.1426 47.2833 30.1176 47C30.1176 47.2832 30.1291 47.5496 30.1513 47.8001C30.123 51.0854 27.8583 51.625 26 51.625C28.8235 51.625 30.1176 53.125 30.1176 56C30.1176 51.625 32.3529 51.625 34 51.625Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.491648,
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58.5694C34.9754 58.4421 34.1981 57.9763 34.0757 56.4445C34.0767 56.3054 34.0713 56.1574 34.0588 56C34.0588 56.1573 34.0645 56.3053 34.0757 56.4445C34.0615 58.2697 32.9292 58.5694 32 58.5694C33.4118 58.5694 34.0588 59.4028 34.0588 61C34.0588 58.5694 35.1765 58.5694 36 58.5694Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.491648,
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M166.133 29.1982C166.133 32.0859 168.606 33.0202 169.843 33.1264C168.269 33.1264 166.133 33.1264 166.133 36.8421C166.133 34.4003 164.897 33.1264 162.199 33.1264C164.11 33.1264 166.133 32.0647 166.133 29.1982Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.491648,
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M140.934 91C140.934 93.8877 143.407 94.822 144.644 94.9281C143.07 94.9281 140.934 94.9281 140.934 98.6439C140.934 96.2021 139.697 94.9281 137 94.9281C138.911 94.9281 140.934 93.8665 140.934 91Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.491648,
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 178.225,
    y: 28.225,
    width: 39.55,
    height: 38.15,
    rx: 1.9,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 182.475,
    y: 32.475,
    width: 6.75,
    height: 6.75,
    rx: 1.19167,
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 33.1166,
    width: 15.75,
    height: 1.8,
    rx: 0.9,
    fill: "#E473FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 36.7836,
    width: 20.25,
    height: 1.8,
    rx: 0.9,
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 182.475,
    y: 43.9252,
    width: 6.75,
    height: 6.75,
    rx: 1.19167,
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 44.6918,
    width: 9,
    height: 1.8,
    rx: 0.9,
    fill: "#E473FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 48.3588,
    width: 14.55,
    height: 1.55,
    rx: 0.775,
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 182.475,
    y: 55.3754,
    width: 6.75,
    height: 6.75,
    rx: 1.19167,
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 56.017,
    width: 20.25,
    height: 1.8,
    rx: 0.9,
    fill: "#E473FF",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 59.684,
    width: 13.5,
    height: 1.8,
    rx: 0.9,
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 178.225,
    y: 28.225,
    width: 39.55,
    height: 38.15,
    rx: 1.9,
    stroke: "#040222",
    strokeWidth: 0.45
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1106_10827)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 29.9648,
    width: 25.9653,
    height: 40,
    rx: 2.125,
    transform: "rotate(-90 45 29.9648)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.475,
    y: 8.475,
    width: 18.8221,
    height: 1.8,
    rx: 0.9,
    fill: "#A0ECE5",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.475,
    y: 11.8607,
    width: 8.86733,
    height: 1.8,
    rx: 0.9,
    fill: "#A0ECE5",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.475,
    y: 23.9281,
    width: 4.56877,
    height: 1.8,
    rx: 0.9,
    fill: "#41D9CC",
    stroke: "#040222",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.7041,
    y: 25.7109,
    width: 9.63603,
    height: 2.25,
    rx: 1.125,
    transform: "rotate(-90 70.7041 25.7109)",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.7197,
    y: 25.7109,
    width: 6.42402,
    height: 2.25,
    rx: 1.125,
    transform: "rotate(-90 74.7197 25.7109)",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.6895,
    y: 25.7109,
    width: 4.81802,
    height: 2.25,
    rx: 1.125,
    transform: "rotate(-90 66.6895 25.7109)",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.7344,
    y: 25.7109,
    width: 11.242,
    height: 2.25,
    rx: 1.125,
    transform: "rotate(-90 78.7344 25.7109)",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.8812,
    y: 7.5502,
    width: 6.75,
    height: 6.75,
    rx: 1.19167,
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.45
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 45.225,
    y: 29.7398,
    width: 25.5153,
    height: 39.55,
    rx: 1.9,
    transform: "rotate(-90 45.225 29.7398)",
    stroke: "#040222",
    strokeWidth: 0.45
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_10827"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 29.9648,
    width: 25.9653,
    height: 40,
    rx: 2.125,
    transform: "rotate(-90 45 29.9648)",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Illustration.c8bfc5fbac93ace9ff5d699b1a24e44a.svg";